<template>
	<div :class="classes">
		<icon v-if="icon" :name="icon" />
		<slot></slot>
	</div>
</template>

<script>
import Icon from './Icon.vue';

export default {
	name: 'UiFlag',
	props: {
		direction: { type: String, default: 'right' },
		icon: { type: String, default: '' },
		color: { type: String, default: 'red' },
	},
	components: { Icon },
	computed: {
		classes() {
			return [
				'ui-flag',
				`ui-flag--${this.direction}`,
				`ui-flag--${this.color}`
			];
		},
	}
};
</script>

<style lang="less">
@import "../../less/_mixins.less";
.ui-flag {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	padding: 3px 6px;
	padding-right: 1rem;
	font-size: 0.75rem;
	font-weight: 500;
	letter-spacing: 0.05rem;
	line-height: 1;
	color: #fff;
	text-transform: uppercase;
	border-radius: 0px 10px 10px 0px;

	&--red {
		background-color: #B12F31;
	}

	&--blue {
		background-color: @BB;
	}

	&--cerulean {
		background-color: @AAEME;
	}

	&--left {
		border-radius: 20px 0 0 20px;
		padding-right: 6px;
		padding-left: 1rem;
	}

	.icon {
		font-size: 15px;
		margin-right: 3px;
	}
}
</style>